export const CHRISTMAS_CAMPAIGNS = 'christmas';
